import { ApiClientService } from '@dfl/react-security';
import { IOrderDiscountSummary, IOrderSummary } from '../interfaces/IOrderSummary';
import { AbstractOrderService } from './abstractOrder.service';

export class AnalyticService<T> extends AbstractOrderService<any> {
  ordersSummary = (params: any): Promise<T> => {
    return this.handleResponse(ApiClientService.post(this.getPath('/order-summary'), params)).then((data) =>
      data?.length ? data[0] : data,
    );
  };

  ordersDiscountSummary = (params: any): Promise<IOrderDiscountSummary> => {
    return this.handleResponse(ApiClientService.post(this.getPath('/discount-summary'), params)).then((data) =>
      data?.length ? data[0] : data,
    );
  };

  productDiscountSummary = (params: any): Promise<IOrderSummary> => {
    return this.handleResponse(ApiClientService.post(this.getPath('/product-discount-summary'), params)).then((data) =>
      data?.length ? data[0] : data,
    );
  };

  ordersAmountHistogram = (params: any) => {
    return this.handleResponse(ApiClientService.post(this.getPath('/order-histogram'), params));
  };

  ordersAmountProviders = (params: any) => {
    return this.handleResponse(ApiClientService.post(this.getPath('/provider-distribution'), params));
  };

  ordersFullSummary = (params: any) => {
    return this.handleResponse(ApiClientService.post(this.getPath('/orders-full-summary'), params));
  };

  ordersAmountByLocation = (params: any) => {
    return this.handleResponse(ApiClientService.post(this.getPath('/location-distribution'), params));
  };

  ordersIncomeByLocation = (params: any) => {
    return this.handleResponse(ApiClientService.post(this.getPath('/location-income-distribution'), params));
  };

  ordersAmountByStatusDistribution = (params: any) => {
    return this.handleResponse(ApiClientService.post(this.getPath('/status-distribution'), params));
  };

  analyticOrderCancellation = (params: any) => {
    return this.handleResponse(ApiClientService.post(this.getPath('/orders-full-summary'), params)).then((data) =>
      data?.length ? data[0] : data,
    );
  };
}

export default new AnalyticService<IOrderSummary>('/ms-auth/api/analytics/order');
